import api from './api';

/**
 * Get all staff users
 */
export const getStaffUsers = async (params = {}) => {
  const response = await api.get('/users/staff', { params });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Update staff user status
 */
export const updateStaffUserStatus = async (userId: any, status: any) => {
  const response = await api.patch(`/users/staff/${userId}/status`, { status });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Get all student users
 */
export const getStudentUsers = async (params = {}) => {
  const response = await api.get('/users/students', { params });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Update student user status
 */
export const updateStudentUserStatus = async (userId: any, status: any) => {
  const response = await api.patch(`/users/students/${userId}/status`, { status });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Get a student's profile
 */
export const getStudentProfile = async (userId: number) => {
  const response = await api.get(`/users/students/${userId}`);
  return response;  // Interceptor already unwraps response.data
};

/**
 * The rides behind a member's "Offered rides" / "Taken rides" counts
 */
export const getStudentRides = async (userId: number, kind: 'offered' | 'taken' | 'bookings') => {
  const response = await api.get(`/users/students/${userId}/rides`, { params: { kind } });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Mark a student academically verified: with an academic email (set and verified),
 * or without one, which requires a reason
 */
export const setAcademicVerification = async (userId: number, academicEmail: string, reason = '') => {
  const response = await api.put(`/users/students/${userId}/academic-verification`, { academicEmail, reason });
  return response;  // Interceptor already unwraps response.data
};

/**
 * Withdraw a student's academic verification
 */
export const removeAcademicVerification = async (userId: number) => {
  const response = await api.delete(`/users/students/${userId}/academic-verification`);
  return response;  // Interceptor already unwraps response.data
};

/**
 * Get user activity (rides and bookings)
 */
export const getUserActivity = async (userId: any) => {
  const response = await api.get(`/users/${userId}/activity`);
  return response;  // Interceptor already unwraps response.data
};
